import __ from "src/utils/Translations";

const getPositionLabel = (count: number): string => {
  if (count === 1) return `${count} ${__("pozycja")}`;

  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return `${count} ${__("pozycji")}`;
  }

  if ([2, 3, 4].includes(lastDigit)) {
    return `${count} ${__("pozycje")}`;
  }

  return `${count} ${__("pozycji")}`;
};

export default getPositionLabel;
